var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTimesCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 7,
    height: 7,
    viewBox: "-0.45 -0.45 7 7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "hk85oxba2a",
    d: "M3.067.096C1.426.096.096 1.426.096 3.067c0 1.642 1.33 2.972 2.971 2.972 1.642 0 2.972-1.33 2.972-2.972 0-1.641-1.33-2.971-2.972-2.971zm1.457 3.751c.057.057.057.148 0 .204l-.474.473c-.057.057-.148.057-.204 0l-.779-.786-.78.786c-.056.057-.147.057-.203 0L1.61 4.05c-.056-.057-.056-.148 0-.204l.786-.779-.786-.78c-.056-.056-.056-.147 0-.203l.475-.475c.056-.056.147-.056.203 0l.78.787.78-.786c.056-.056.147-.056.203 0l.474.475c.057.056.057.147 0 .203l-.787.78.786.78z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimesCircle);
export default __webpack_public_path__ + "static/media/times-circle.b0d198654ae4c1a27745abe4288c2fe3.svg";
export { ForwardRef as ReactComponent };